import {FC} from 'react';

import Button from '~/common/Button/Button';

import Dropdown from '../HeaderMenu/parts/Dropdown';
import s from './styles.module.scss';

const HamburgerError: FC = () => (
  <div className={s['error-boundary']}>
    <Dropdown>
      <div className={s['error-boundary__dropdown-content']}>
        <div className={s['error-boundary__card']}>
          <h2 className={s['error-boundary__title']}>Something went wrong</h2>
          <p className={s['error-boundary__content']}>We already working on it!</p>
          <Button className={s['error-boundary__button']} onClick={() => window.location.reload()}>
            Reload
          </Button>
        </div>
      </div>
    </Dropdown>
  </div>
);

export default HamburgerError;
